import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	previous: {
		id: 'custom-sites-extensions.link-cards.row-orientation.previous',
		defaultMessage: 'Previous',
		description:
			'Label text for the button that, when clicked, goes back one card and displays the previous card',
	},
	next: {
		id: 'custom-sites-extensions.link-cards.row-orientation.next',
		defaultMessage: 'Next',
		description:
			'Label text for the button that, when clicked, goes forward one card and displays the next card',
	},
});
